export const ChevronDown = ({ width = 11, height = 6 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 5.5L10.2631 0.25H0.73686L5.5 5.5Z" fill="black" />
    </svg>
  );
};

export const ChevronUp = ({ width = 11, height = 6 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.5 0.5L10.2631 5.75H0.73686L5.5 0.5Z" fill="black" />
    </svg>
  );
};
